import React from 'react';
import { FiBell, FiAlertCircle, FiBookOpen, FiCalendar, FiAward } from 'react-icons/fi';

export const getNotificationIcon = (type) => {
  switch (type) {
    case 'course_content':
      return <FiBookOpen size={16} />;
    case 'attendance':
      return <FiCalendar size={16} />;
    case 'grade':
      return <FiAward size={16} />;
    case 'announcement':
      return <FiAlertCircle size={16} />;
    default:
      return <FiBell size={16} />;
  }
};

export const getNotificationIconClass = (type) => {
  switch (type) {
    case 'course_content':
      return 'info';
    case 'attendance':
      return 'warning';
    case 'grade':
      return 'success';
    case 'announcement':
      return 'error';
    default:
      return 'info';
  }
};

export const formatTimeAgo = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInMinutes = Math.floor((now - date) / (1000 * 60));

  if (diffInMinutes < 1) return 'Just now';
  if (diffInMinutes < 60) return `${diffInMinutes}m ago`;

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) return `${diffInHours}h ago`;

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) return `${diffInDays}d ago`;

  return date.toLocaleDateString();
};
